import styled from 'styled-components';

interface WidthProps {
  width: string | number;
}

export const Container = styled.button<WidthProps>`
  font-size: 1rem;
  font-weight: 500;
  display: block;
  outline: none;
  padding: 6px 22px;
  font-size: 18px;
  font-size: 1rem;
  border-radius: 1.75rem;
  border-radius: 29px;
  text-decoration: none;
  color: white;
  border: none;
  min-height: 34px;
  margin: auto 0;
  text-align: center;
  background-color: #ff8723;
  max-width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};

  &.fat {
    min-height: 47px;
  }

  &:hover {
    cursor: pointer;
  }

  &.big {
    width: 90%;
    margin: auto;
  }

  &.outline {
    background: white;
    color: var(--color-btn-orange);
    border: 1px solid var(--color-btn-orange);
  }

  &.topspace {
    margin-top: 100px;
  }

  &.terms-btn {
    margin-left: auto;
    margin-top: 20px;

    @media (max-width: 768px) {
      width: 100vw;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1.5rem;
      border-radius: 0;
    }
  }

  &:disabled,
  &.disabled {
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    img {
      width: auto;
    }
  }
`;
